import { useActivityTypesContext } from '../../../../context'
import { useCallback } from 'react'
import { closeActivityTypeFormActionCreator } from '../../../../state'

export function useHandlers() {
  const [, dispatch] = useActivityTypesContext()

  const handleCancelClick = useCallback(() => {
    dispatch(closeActivityTypeFormActionCreator())
  }, [dispatch])

  return {
    handleCancelClick,
  }
}
